import { connect } from 'react-redux';
import Billing from 'account/components/billing';
import { fetchCountriesIfNeeded, updateUserRequest, updateUserLocal } from 'common/ducks/user';
import { fetchInvoicesIfNeeded } from 'common/ducks/billing';

const mapStateToProps = ({user: {countries, profile_data}, billing: {invoices}}) => {
  return {
    countries,
    invoices,
    user: profile_data
  }
}

export default connect(mapStateToProps, {
  fetchCountriesIfNeeded,
  fetchInvoicesIfNeeded,
  updateUserRequest,
  updateUserLocal
})(Billing);



// WEBPACK FOOTER //
// ./account/containers/billing.js